// Product cards: the worn photo replaces the display photo on hover (mouse)
// or while a finger rests on the card (touch, including while swiping a rail).
// A quick tap must not swap: iOS Safari holds back the click when content
// appears under the finger, which made product cards need two taps to open.
// The worn photo loads only when it can be asked for: on first hover with a
// mouse, or when the card comes near the screen on a touch device.
(() => {
  if (window.scCardPreview) return;
  window.scCardPreview = true;

  const touch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  const RELEASE = 700;
  const HOLD = 260;

  const loadPreview = (card) => {
    const preview = card.querySelector('.sc-product-card__preview');
    if (!preview || preview.src || !preview.dataset.scPreviewSrc) return;
    preview.addEventListener('load', () => card.setAttribute('data-sc-preview-ready', ''), { once: true });
    preview.srcset = preview.dataset.scPreviewSrcset;
    preview.src = preview.dataset.scPreviewSrc;
  };

  const nearby = touch && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        nearby.unobserve(entry.target);
        loadPreview(entry.target);
      }), { rootMargin: '200px' })
    : null;

  const bind = () => {
    document.querySelectorAll('.sc-product-card--genesis-preview').forEach((card) => {
      if (card.dataset.scPreviewBound) return;
      card.dataset.scPreviewBound = 'true';
      if (!card.querySelector('.sc-product-card__preview')) return;

      card.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') loadPreview(card);
      });
      card.addEventListener('focusin', () => loadPreview(card));

      if (touch) {
        if (nearby) nearby.observe(card);
        let timer;
        let hold;
        const show = () => {
          window.clearTimeout(hold);
          card.classList.add('is-touched');
        };
        card.addEventListener('touchstart', () => {
          loadPreview(card);
          window.clearTimeout(timer);
          window.clearTimeout(hold);
          hold = window.setTimeout(show, HOLD);
        }, { passive: true });
        card.addEventListener('touchmove', show, { passive: true });
        const release = () => {
          window.clearTimeout(hold);
          window.clearTimeout(timer);
          if (card.classList.contains('is-touched')) {
            timer = window.setTimeout(() => card.classList.remove('is-touched'), RELEASE);
          }
        };
        card.addEventListener('touchend', release, { passive: true });
        card.addEventListener('touchcancel', release, { passive: true });
      }
    });
  };

  window.scCardPreviewBind = bind;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  // Cards shown later (gift tabs) bind after the click that reveals them;
  // cards added by the collection's infinite scroll bind as they arrive.
  document.addEventListener('click', () => window.requestAnimationFrame(bind));
  const main = document.querySelector('collection-component') && document.querySelector('#MainContent');
  if (main && 'MutationObserver' in window) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => { queued = false; bind(); });
    }).observe(main, { childList: true, subtree: true });
  }
})();
